// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._filterPanel_vol6d_1 {
  --pa-filter-panel-top-inner: var(--pa-filter-panel-top, 60px);
  --pa-filter-panel-left-inner: var(--pa-filter-panel-left, 0);
  position: sticky;
  top: var(--pa-filter-panel-top-inner);
  left: var(--pa-filter-panel-left-inner);
  width: 360px;
}
@media (min-width: 576px) and (max-width: 1199px) {
  ._filterPanel_vol6d_1 {
    width: 320px;
  }
}
@media (min-width: 0px) and (max-width: 767px) {
  ._filterPanel_vol6d_1 {
    width: 100%;
  }
}
._filterPanel__parameters_vol6d_19 {
  padding-bottom: var(--perxis-auto-gap-vertical-yellow-inner);
}
._filterPanel__parameters_vol6d_19 .ant-5_24_1-collapse-header-text {
  overflow: hidden;
  text-overflow: ellipsis;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
